import React from 'react';

function SectionTitle({ children, timeStamp }) {
	return (
		<div className='flex flex-middle flex-between'>
			<h2 className='fs-7 fw-600 c-neutral-900'>{children}</h2>
      {timeStamp && <span className='d-none--xs c-neutral-400 fs-2'>Last updated: {timeStamp}</span> }
		</div>
	);
}

export default SectionTitle;
